export function pruneUnfillableMotivations<
  T extends { jobPositionID?: string | null; motivation?: string | null },
>(motivations: T[], currentJobIDs: string[]): T[] {
  return motivations.filter(
    motivation =>
      !!motivation.motivation?.trim() ||
      (motivation.jobPositionID != null && currentJobIDs.includes(motivation.jobPositionID)),
  );
}
